import { createContext } from 'react';

export type XYChartDownloadContextValue = {
  downloadDataCallback?: () => void;
};

export const XYChartDownloadContext =
  createContext<XYChartDownloadContextValue>({});

XYChartDownloadContext['displayName'] = 'XYChartDownloadContext';
